module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "blurb-and-subscription-container w-100",
    class: _vm.$vuetify.breakpoint.width <= 1280 ? '' : 'py-5'
  }, [_c('div', {
    staticClass: "blurb-and-subscription"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between gap-8",
    class: _vm.$vuetify.breakpoint.width <= 1280 ? 'flex-column' : ''
  }, [_c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "font-space-grotesk font-weight-500",
    class: _vm.$vuetify.breakpoint.width <= 1280 ? 'text-32 text-center display-flex white--text font-weight-700' : 'text-50 white--text'
  }, [(_vm.$vuetify.breakpoint.width > 1280) ? _c('span', [_vm._v("Streaming Revenue"), _c('br'), _vm._v("Estimator")]) : _c('span', [_vm._v("Estimate Streaming Revenue")])])]), _vm._v(" "), _c('div', {
    staticClass: "subscription-container"
  }, [_c('div', {
    staticClass: "subscription-plan",
    class: {
      'bg-white': _vm.$vuetify.breakpoint.width > 1280
    }
  }, [_c('div', {
    staticClass: "text-center overflow-hidden font-space-grotesk"
  }, [_c('div', {
    staticClass: "pa-7"
  }, [_c('div', {
    staticClass: "title-money"
  }, [_vm._v(_vm._s(_vm.formattedListenerCount))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold title-money-note text-14 pt-2"
  }, [_vm._v("\n                  Monthly listeners\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "slider-component"
  }, [_c('div', {
    staticClass: "slide-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.range),
      expression: "formData.range"
    }],
    ref: "input",
    staticClass: "slider",
    attrs: {
      "type": "range",
      "min": 0,
      "max": _vm.increments.length - 1
    },
    domProps: {
      "value": (_vm.formData.range)
    },
    on: {
      "input": _vm.updateRangePrice,
      "__r": function($event) {
        _vm.$set(_vm.formData, "range", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "revenue-output-box"
  }, [_c('div', {
    staticClass: "result-price"
  }, [_vm._v(_vm._s(_vm.youSoundRevenue))]), _vm._v(" "), _c('div', {
    staticClass: "result-price-text"
  }, [_vm._v("YOUSOUND")])]), _vm._v(" "), _c('div', {
    staticClass: "revenue-output-box"
  }, [_c('div', {
    staticClass: "result-price"
  }, [_vm._v(_vm._s(_vm.dspRevenue))]), _vm._v(" "), _c('div', {
    staticClass: "result-price-text"
  }, [_vm._v("OTHER MUSIC PLATFORMS")])])])])])])])]), _vm._v(" "), (_vm.$vuetify.breakpoint.width <= 1280) ? _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('button', {
    staticClass: "btn-sign-up",
    on: {
      "click": _vm.redirectToAppStore
    }
  }, [_vm._v("\n      Sign up\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3312f395","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landing-new/components/RevenueCalculator.vue
// module id = 1674
// module chunks = 180